// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TJZ5s","left":"styles_left__1gadr"};